import { useEffect } from 'react';
import { useTheme, Theme } from '@mui/material/styles';

/**
 * Mirror MUI's palette mode onto <html data-wf-theme="light|dark">.
 *
 * React-admin's light/dark toggle changes no attribute or class in the DOM — it
 * only sets the computed `color-scheme` on <html>, which CSS cannot select on.
 * Stylesheets that are not written in MUI's `sx` therefore have no way to
 * follow the theme without this.
 *
 * Called once from AdminLayout so it covers every page, including the dialogs
 * and drawers MUI portals out to document.body.
 */
export function useThemeAttribute(): void {
    const theme: Theme = useTheme();
    const mode: string = theme.palette.mode;

    useEffect((): () => void => {
        const root: HTMLElement = document.documentElement;
        root.setAttribute('data-wf-theme', mode);
        return (): void => {
            root.removeAttribute('data-wf-theme');
        };
    }, [mode]);
}
